<template>
  <div class="InfoWindow bsj-infowindow">
    <div v-if="vehInfo" class="InfoWindow__header">
      <div class="InfoWindow__title">
        <!-- InfoWindow__tag_stop: vehInfo.Z === 2 || vehInfo.Z === 3, -->
        <div
          class="InfoWindow__tag"
          :class="{InfoWindow__tag_online: vehInfo.Z === 1,

          InfoWindow__tag_offline: vehInfo.Z === 0 || vehInfo.Z === 2 || vehInfo.Z === 3}"
        >{{statusFormat(vehInfo.Z)}}</div>
        <div class="InfoWindow__veh">{{vehInfo.P}}</div>
        <div class="InfoWindow__group">{{"/ " + vehInfo.bmsType}}</div>
      </div>
      <el-button
        @click="jump()"
        type="text"
        size="medium"
        icon="iconfont icon-trajectory"
        class="InfoWindow__playback-btn"
      >轨迹</el-button>
      <el-button
        @click="$emit('onInfoClose')"
        type="text"
        size="medium"
        icon="el-icon-close"
      />
    </div>
    <el-form
      v-if="vehInfo"
      label-position="left"
      size="mini"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="速度:">
            {{ vehInfo.S }} km/h
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="里程:">
            {{ vehInfo.L }} km
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 欣旺达新数据 start -->
      <el-row v-if="vehInfo.T == 'GPRS-SUNWODA'">
        <!-- <el-col :span="12">
          <el-form-item label="加热状态:">
            {{ vehInfo.heating?'开启':'关闭'}}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="送风状态:">
            {{ vehInfo.equiblast?'开启':'关闭' }}
          </el-form-item>
        </el-col> -->
        <el-col :span="12">
          <el-form-item label="精确度:">
            {{ vehInfo.precision }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="上报原因状态:">
            {{ vehInfo.uploadReason == 1?'定时位置上报':vehInfo.uploadReason == 2?'请求定位上报':vehInfo.uploadReason == 3?'重启定位上报':vehInfo.uploadReason == 5?'指令定位上报':'预留' }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="失效模式状态:">
            {{ vehInfo.failMode == 1?'正常模式':vehInfo.failMode == 2?'485通讯失效':'定位失效' }}
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 欣旺达新数据 end -->
      <el-row>
        <el-col :span="12">
          <el-form-item label="信号时间:">
            {{ vehInfo.R }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="定位时间:">
            {{ vehInfo.PT }}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="地址:">
            {{ address }}
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
// import TypeSelect from "@/components/TypeSelect/index.vue";

export default {
  components: {
    // TypeSelect
  },

  props: {
    vehInfo: [Object]
  },
  data() {
    return {
      address: "暂无数据"
    };
  },
  mounted() {
    this.GetGeo();
    console.log(this.vehInfo);
  },
  watch: {
    vehInfo: {
      handler() {
        this.GetGeo();
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    jump() {
      let routeData = this.$router.resolve({path: 'playback', query: {vehInfo: this.vehInfoFormat(this.vehInfo)}});
      window.open(routeData.href, '_blank');
    },
    //处理vehInfo
    vehInfoFormat(data) {
      let data2 = JSON.parse(JSON.stringify(data));
      data2.terminalNo = data2.N;
      return JSON.stringify(data2);
    },
    //['离线','行驶','停车','从未上线','默认从未上线'][vehInfo.Z]
    statusFormat(data) {
      if (data === 1) {
        return "移动";
      } else {
        return "静止";
      }
    },
    async GetGeo() {
      if(!this.vehInfo) return;
      const addressList = await this.$API.GetGeo([
        { lat: this.vehInfo.Y, lon: this.vehInfo.X }
      ]);
      this.address = addressList[0].address;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-form-item {
  margin-bottom: 0px !important;

  &__content,
  &__label {
    font-size: 12px !important;
  }

  &__label {
    color: #888 !important;
  }
}

.el-row {
  padding: 0 16px;
}

::v-deep .el-tabs__item {
  padding-left: 20px !important;
}
.bsj-infowindow::before {
  background-color: #f8f8f8;
}
.InfoWindow {
  padding: 0;
  width: 450px;

  &__header {
    padding: 5px 16px;
    display: flex;
    align-items: center;
  }

  &__title {
    @include ellipsis;
    flex: 1;
    display: flex;
    align-items: center;
  }

  &__split-line {
    background: rgba(229, 229, 229, 1);
    height: 30px;
    line-height: 30px;
    padding: 0 16px;
    margin: 10px 0;
  }

  &__tag {
    padding: 3px 6px;
    color: #fff;
    font-size: 10px;
    margin-right: 5px;
    user-select: none;

    &_online {
      background: rgba(30, 198, 144, 1);
    }

    &_stop {
      background: #2a83de;
    }

    &_offline {
      background: #7d7e80;
    }
  }

  &__veh {
    font-size: 14px;
    font-weight: bold;
    margin-right: 5px;
  }

  &__group {
    font-size: 12px;
  }

  ::v-deep &__playback-btn {
    i {
      font-size: 14px;
      margin-right: 5px;
    }
  }
}
</style>
<style>
.infoBox>img{
  display: none;
}
</style>
